<template>

</template>

<script>
import API from "@/services/api";
import {mapActions} from "vuex";

export default {
  name: "LoginHash",
  async created() {
    try {
      const res = await API.loginHash(this.$route.params.hash);

      this.setCurrentUser(res.data);
      this.$router.push('/')
    } catch (err) {
      this.$events.fire('showError', err.response.data);
    }

  },
  methods: {
    ...mapActions('currentuser', ['setCurrentUser']),
  }
}
</script>

<style scoped>

</style>